import React from "react";
import { Carousel, Container } from "react-bootstrap";
import banner5 from "../../assets/images/slider/banner5.webp";
import banner3 from "../../assets/images/slider/banner3.webp";
import banner7 from "../../assets/images/slider/banner7.jpg";
import tigerTwo from "../../assets/images/slider/tigertwo.webp";  // Keep only tigerTwo
import "../Banner/banner.css";
import { TigerPawButton } from '../Buttons/TigerPawButton';

const sliderData = [
  {
    image: banner5,
    title: "",
    subtitle: "",
    description: "",
    className: "highlight-slide"
  },
  {
    image: banner3,
    title: "",
    subtitle: "",
    description: "",
    className: "highlight-slide"
  },

  {
    image: banner7,
    title: "DISCOVER CORBETT",
    subtitle: "Nature's Paradise",
    description: "Immerse yourself in the pristine wilderness of Jim Corbett National Park, where adventure meets serenity. Experience the thrill of wildlife spotting and the peace of natural surroundings.",
    className: "normal-slide"
  }
];

const Banner = () => {
  return (
    <>
      <section className="slider">
        <Carousel 
          variant="dark" 
          controls={false} // Remove navigation buttons
          touch={true} // Enable touch controls
          interval={2000} // Set slide duration to 2 seconds (2000ms)
        >
          {sliderData.map((slide, index) => (
            <Carousel.Item key={index} className={slide.className}>
              <img 
                src={slide.image} 
                className="d-block w-100" 
                alt={`Slide ${index + 1}`} 
              />
              <Carousel.Caption>
                <div className="slider_des">
                  <h5 className="heading">
                    {slide.title} <span>{slide.subtitle}</span>
                  </h5>
                  <p className="sub_text">
                    {slide.description}
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      <section className="banner-description" id="about-section">
        <Container>
          <h2 className="description-title text-center">Corbett Aura</h2>
          <div className="description-content">
            <p className="text-left">
              Corbett Aura is your trusted travel companion for unforgettable experiences in and around Jim Corbett National Park. We specialize in curated tour packages, resort stays, and jeep safari bookings, ensuring a seamless blend of adventure, comfort, and natural beauty.
            </p>
            <p className="text-left">
              Whether you're looking for a quick weekend escape, a deep dive into the wilderness, or a personalized holiday plan — we've got you covered. Our team is passionate about delivering authentic Corbett experiences, from exploring hidden trails to arranging stays in scenic resorts right on the park's edge.
            </p>
            <p className="text-left">
              With a strong local network and expert guidance, we take care of every detail — so you can focus on the thrill of the wild and the calm of nature.
            </p>
          </div>
        </Container>
      </section>

      <section className="tourist-zones">
        <Container>
          <div className="zones-content">
            <h2 className="section-title">The Tourist Zones</h2>
            <p className="zone-intro">
              To promote tourism in this region, the Corbett National Park has been divided into six major different tourism zones. These are the manifested core or buffer areas of the park where visitors can be a part of the wildlife safari and can relish the tempting behaviour of the animals with their bare eyes in the vicinity.
            </p>
          </div>

          <div className="image-showcase">
            <img src={banner5} alt="Corbett National Park Landscape" className="showcase-img" />
            <img src={tigerTwo} alt="Tiger at Corbett" className="showcase-img" />
          </div>
          
          <div className="zones-grid">
            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Bijrani Zone</h3>
                <p>Bijrani is a well-known and scenic zone in Jim Corbett National Park, famous for its excellent tiger population. Located near the Aamdanda Gate, this zone offers both morning and evening jeep safaris through dense Sal forests and lush grasslands. Its close proximity to Ramnagar makes it an ideal choice for short and convenient wildlife excursions.</p>
              </div>
            </div>

            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Garjia Zone</h3>
                <p>Garjia zone offers a unique blend of spiritual and wildlife experiences. Famous for the Garjia Temple and situated along the Kosi River, this zone provides excellent opportunities for wildlife viewing and bird watching while being easily accessible from Ramnagar.</p>
              </div>
            </div>

            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Jhirna Safari Zone</h3>
                <p>Jhirna is another important tourist zone in the Jim Corbett National park which is open for tourists round the year. Jhirna Gate is located at a distance of 16 km from Ramnagar city.</p>
              </div>
            </div>

            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Dhikala Zone</h3>
                <p>Being the largest and the most diversified jungle safari zone in Corbett, Dhikala is famous for its bountiful natural beauty as well as for offering the best sight for its exotic fauna.</p>
              </div>
            </div>

            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Dhela Safari Zone</h3>
                <p>Dhela is a new eco-tourism zone in the Corbett National Park which was included in the tiger reserve zone in November 2014. This is the only area in the reserve's buffer zone open for tourists in CTR.</p>
              </div>
            </div>

            <div className="zone-card">
              <div className="zone-icon">
                <TigerPawButton />
              </div>
              <div className="zone-content">
                <h3>Durga Devi Zone</h3>
                <p>Located at the north eastern boundary of the Jim Corbett National Park, Durga Devi zone is the heaven on planet earth for those who are fond of bird watching.</p>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Banner;
